<template>
  <div class="policy-pillar-component">
    <header>
      <site-menu theme="dark" class="menu"/>
    </header>
    <section class="top inner">
      <div class="categories">
        <ul>
          <li>&middot; State &amp; Federal Legislation</li>
          <li>&middot; Taxation</li>
          <li>&middot; Public Opinion</li>
          <li>&middot; Litigation</li>
          <li>&middot; Local Bureaucracy</li>
          <li>&middot; Political Opposition</li>
          <li>&middot; Lobbying Efforts</li>
          <li>&middot; Policy Endorsements</li>
        </ul>
        <img src="../assets/pillars/policy/illustration.jpg" />
      </div>
      <div class="speakers">
        <h1>Featured Speakers/Workshops</h1>
        <article>
          <div v-if="!speakers">
            <div class="fallback-title">
              Sessions will take place in the<br/>
              Congressional Auditorium of the United States Capitol</br>
              10th - 12th of April 2019<br/><br/>
              Keep up to date by signing up to our newsletter
            </div>
            <subscribe css-class="big" placeholder="Enter email here" />
          </div>
          <ul v-if="speakers">
            <li v-for="speaker in speakers">
              <img :src="require(`@/assets/pillars/medical/${speaker.imageName}`)" />
              <div class="name">{{speaker.name}}</div>
              <div class="category">{{speaker.category}}</div>
              <div class="title">{{speaker.session}}</div>
              <div class="date">{{speaker.sessionDate}}</div>
              <div class="more">more</div>
            </li>
          </ul>
        </article>
      </div>
    </section>
    <divider v-if="featuredSpeaker" />
    <section class="featured-speaker inner" v-if="featuredSpeaker">
      <h1>
        <img src="../assets/mini-logo-white.svg" class="mini-logo" />
        <span>Featured Speaker</span>
      </h1>
      <article>
        <div class="text">
          <img src="../assets/pillars/policy/featured_speaker.png" />
          <p>Join Prof. Laurie Ramseyer in conversation on the topic of Cannabis and Pharmaceuticals Mitsubishi Professor of Japanese Legal Studies at the Harvard Law School, has been conferred the Order of the Rising Sun, Gold Rays with Neck Ribbon, from the Japanese government. One of the oldest and highest national decorations, this award recognizes her extensive contributions to the development of studies in the U.S.</p>
        </div>
        <div class="info">
          <div class="title">Info</div>
          <div class="location">Location</div>
          <div class="save-the-date">Save the date</div>
          <div class="contact">Contact</div>
        </div>
      </article>
    </section>
  </div>
</template>
<script>
  import SiteMenu from '@/components/SiteMenu.vue'
  import Slideshow from '@/components/Slideshow.vue'
  import Divider from '@/components/Divider.vue'
  import Subscribe from '@/components/Subscribe.vue'

  export default {
    name: "policy-pillar-component",
    components: { SiteMenu, Slideshow, Divider, Subscribe },
    data() {
      return {
        speakers: null,
        featuredSpeaker: null,
      }
    },
  }
</script>
<style lang="scss" scoped>
  $pilar-color: $color-3;

  .policy-pillar-component {
    position: relative;
  }
  .banner {
    font-family: Times, 'Times New Roman', serif;
    color: #fff;
    position: absolute;
    top: 170px;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    padding: 30px 0;
    text-align: center;
    font-size: 35px;
    .line-2 {
      margin-top: 30px;
      font-weight: bold;
    }
  }
  section.top {
    overflow: hidden;
    margin: 20px auto;
  }
  .categories {
    position: relative;
    border-radius: 15px;
    border: 15px solid $pilar-color;
    background: $pilar-color;
    color: #fff;
    margin-top: 60px;
    li {
      line-height: 22px;
      font-size: 18px;
    }
    img {
      width: 100%;
      border-radius: 15px;
      text-align: center;
      background: #fff;
    }
  }
  .speakers {
    float: left;
    width: 915px;
    height: 370px;
    margin-left: 20px;
    h1 {
      margin: 10px 0 0 0;
      text-align: center;
      text-transform: uppercase;
      font-size: 40px;
      color: $pilar-color;
    }
    img {
      width: 473px;
    }
    article {
      position: relative;
      border-radius: 15px;
      background: #fff;
      color: #888;
      padding: 15px;
      margin: 18px 15px 0 15px;
      height: 340px;
      &::before {
        content: '';
        background: $pilar-color;
        position: absolute;
        border-radius: 15px;
        top: -15px;
        left: -15px;
        bottom: -15px;
        right: -15px;
        z-index: -1;
      }
      img {
        width: 150px;
        border-radius: 150px;
        margin-bottom: 15px;
      }
      li {
        text-align: center;
        width: 25%;
        float: left;
      }
      .name, .category {
        line-height: 1.5;
      }
      .title {
        color: #999;
        font-size: 20px;
        line-height: 1.4;
        height: 65px;
        margin: 5px 0;
      }
      .date {
        color: #333;
      }
      .more {
        color: #fff;
        background: $pilar-color;
        width: 110px;
        border-radius: 10px;
        margin: 7px auto 0;
        padding: 3px 0 5px 0;
        text-transform: uppercase;
      }
    }
  }
  section.featured-speaker {
    border: 2px solid $color-7;
    box-sizing: border-box;
    padding: 15px;
    h1 {
      overflow: hidden;
      margin-top: 5px;
      .mini-logo {
        display: block;
        float: left;
        background: $pilar-color;
        width: 40px;
        padding: 5px;
        border-radius: 30px;
      }
      span {
        display: block;
        float: left;
        color: $color-8;
        font-size: 40px;
        line-height: 50px;
        margin-left: 20px;
        font-family: Times, 'Times New Roman', serif;
      }
    }
    article {
      overflow: hidden;
      .text {
        float: left;
        width: calc(45% - 20px);
        margin-right: 20px;
        img {
          width: 100%;
        }
        p {
          color: #888;
          font-size: 21px;
          line-height: 1.3;
        }
      }
      .info {
        box-sizing: border-box;
        background: $color-10;
        width: 55%;
        padding: 20px;
        float: left;
        color: #fff;
        .title {
          text-transform: uppercase;
          text-align: center;
          font-size: 28px;
          padding: 5px 0;
        }
        .location, .save-the-date, .contact {
          text-transform: uppercase;
        }
        .location, .save-the-date {
          height: 200px;
        }
        .contact {
          height: 140px;
        }
      }
    }
  }
  .fallback-title {
    text-align: center;
    padding-top: 50px;
    font-size: 25px;
  }
  @media (min-width: 501px) {
    .categories {
      float: left;
      height: 370px;
      width: 265px;
      img {
        position: absolute;
        bottom: 0px;
        left: 0;
      }
    }
  }
  @media (max-width: 500px) {
    .categories {
      float: none;
      width: calc(100% - 60px);
      margin: 30px 15px 15px;
      img {
        margin-top: 15px;
      }
    }
    .speakers {
      float: none;
      width: calc(100% - 30px);
      margin: 15px;
      height: auto;
      h1 {
        font-size: 22px;
        margin: 30px 15px;
      }
      article {
        width: calc(100% - 30px);
        height: auto;
        box-sizing: border-box;
      }
    }
    .fallback-title {
      padding-top: 0;
      font-size: 18px;
    }
  }
</style>